/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */

import { DatasourceTableViewWithWrappers } from './DatasourceTableViewWithWrappers';

export default DatasourceTableViewWithWrappers;

/**
 * @deprecated Use `import { DatasourceTableViewWithWrappers } from '@atlaskit/link-datasource/datasource-table-view-with-wrappers'` instead.
 */
export { DatasourceTableViewWithWrappers } from './DatasourceTableViewWithWrappers';
/**
 * @deprecated Use `import { DatasourceTableViewWithWrappers } from '@atlaskit/link-datasource/datasource-table-view-with-wrappers'` instead.
 */
export { DatasourceTableViewWithWrappers as DatasourceTableView } from './DatasourceTableViewWithWrappers';
